import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttributionTypeDTO, ProfileDTO } from '../model/user-profiles-model';

@Injectable({
  providedIn: 'root',
})
export class UserProfilesServiceApi {
  constructor(private _http: HttpClient) {}

  public getAtributionsProfile(attribution: AttributionTypeDTO): Observable<AttributionTypeDTO[]> {
    return this._http.post<AttributionTypeDTO[]>(
      environment.URL_BASE_ADMIN + environment.subUrlAttributions,
      attribution
    );
  }

  public postUpdateAttributions(attribution: AttributionTypeDTO): Observable<AttributionTypeDTO> {
    return this._http.post<AttributionTypeDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlUpdateAttributions,
      attribution
    );
  }

  public postDeleteProfile(profile: ProfileDTO): Observable<boolean> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlDeleteProfile, profile);
  }

  public postCreateProfile(profile: ProfileDTO): Observable<any> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlCreateProfile, profile);
  }

  public postUpdateProfile(profile: ProfileDTO): Observable<any> {
    return this._http.post<boolean>(environment.URL_BASE_ADMIN + environment.subUrlUpdateProfile, profile);
  }

  public postGetProfiles(profile: any): Observable<ProfileDTO[]> {
    return this._http.post<ProfileDTO[]>(environment.URL_BASE_ADMIN + environment.subUrlGetProfiles, profile);
  }

  public postGetProfile(profile: any): Observable<ProfileDTO> {
    return this._http.post<ProfileDTO>(environment.URL_BASE_ADMIN + environment.subUrlGetProfile, profile);
  }
}
